import {removeAccents} from '@s-ui/js/lib/string'
import {filterBasicAllSelectionsId} from '@adv-mt/mt-filter-basic'

import {BASE_ELEMENTS_TYPES, FILTER_WRAPPER_TYPES_WITH_FIELDSET, TYPES} from '../config.js'
import {generateUniqueId, parseUniqueId} from './idUtils.js'

const getIsIncluded = ({label, search}) => {
  return removeAccents(String(label))
    .toUpperCase()
    .includes(removeAccents(String(search)).toUpperCase())
}

const getFilteredItemsBySearch = ({items, search}) => items.filter(({label}) => getIsIncluded({label, search}))

export const getCurrentOptions = ({options, search}) => {
  // Returns options where the group item or a nestedItem matches the search
  const filteredOptionsBySearch = options.filter(
    ({label, nestedItems = []}) =>
      getIsIncluded({label, search}) ||
      nestedItems.some(({label: nestedItemLabel}) => getIsIncluded({label: nestedItemLabel, search}))
  )

  // Returns only the nestedItems matching the search
  return filteredOptionsBySearch.map(({nestedItems = [], ...rest}) => {
    const filteredItemsByText = getFilteredItemsBySearch({items: nestedItems, search})

    return {
      ...rest,
      isIndeterminate: Boolean(filteredItemsByText.length) && filteredItemsByText.length !== nestedItems.length,
      nestedItems: filteredItemsByText.length ? filteredItemsByText : nestedItems
    }
  })
}

export const getNormalizedValue = ({group, value}) =>
  Object.fromEntries(
    Object.entries(value || {}).map(([filterKey, filterValue]) => [
      filterKey,
      Array.isArray(filterValue) && !filterValue.length
        ? [generateUniqueId({group, id: filterBasicAllSelectionsId, name: filterKey})]
        : filterValue.map(id => generateUniqueId({group, id, name: filterKey}))
    ])
  )

export const getNormalizedFilters = ({filters, group}) =>
  filters.map(({allSelectionsId, name, options, ...filter}) => ({
    ...filter,
    allSelectionsId: generateUniqueId({group, id: allSelectionsId || filterBasicAllSelectionsId, name}),
    name,
    options: options.map(({id, nestedItems, ...option}) => ({
      ...option,
      id: generateUniqueId({group, id, name}),
      nestedItems: nestedItems?.map(nestedItem => ({
        ...nestedItem,
        id: generateUniqueId({group, id: nestedItem.id, name})
      }))
    }))
  }))

const getHasMoreThanOneFilter = ({filters}) => filters.length > 1

const getIsWrapperWithFieldset = ({wrapper}) => FILTER_WRAPPER_TYPES_WITH_FIELDSET.includes(wrapper)

const getHasFieldset = ({filters, wrapper}) =>
  (getIsWrapperWithFieldset({wrapper}) && getHasMoreThanOneFilter({filters})) || wrapper === TYPES.NONE

export const getBaseElementType = ({filters, wrapper}) =>
  getHasFieldset({filters, wrapper}) ? BASE_ELEMENTS_TYPES.FIELDSET : BASE_ELEMENTS_TYPES.DIV

export const getParsedValue = ({value}) =>
  value.map(uniqueId => {
    const {id} = parseUniqueId({uniqueId})
    return id
  })
